import React, { useState, useEffect } from 'react';
import http from 'lc-http';
import Common from './common';
import NonPNIGrid from './non-pni-grid';
import { NonPniNewPRPDescription, NonPniNewPRPModalContent, NonPniOldPRPDescription, NonPniOldPRPModalContent } from '../../utils/constants'

const NonPNI = ({
  showPNIAndPRP,
  fixedRatePlan,
  practiceType,
  id,
  shouldShowUpdatedAdsTerms
}) => {
  const [minimumRate, setMinimumRate] = useState('');
  useEffect(() => {
    const getRates = () => http.get('/patientsolutions/enroll/get-rates')
      .then(res => res.data)
      .then(({ LC_FIXED_RATE_PLAN: { minRate } }) => setMinimumRate(minRate));

    getRates();
  }, []);

  const planName = showPNIAndPRP ?
    (fixedRatePlan ? 'fixed-rate-plan' : 'promotional-rate-plan') :
    'fixed-rate-plan-alone';
  const { title, subTitle, description, modalContent } = getCommonProps();

  return (
    <div className={planName}>
      <Common
        id={id}
        title={title}
        boxText='Automatically included with enrollment. No action is needed.'
        subTitle={subTitle}
        description={description}
        modalContent={modalContent}
        noInterestPlan={false}
      />
      <NonPNIGrid
        fixedRatePlan={fixedRatePlan}
        practiceType={practiceType}
      />
    </div>
  );

  function getCommonProps() {
    if (fixedRatePlan)
      return {
        title: 'Installment Loans',
        subTitle: 'Installment Loan',
        description: `Budget-friendly terms and fixed rates starting at ${minimumRate}% APR based on amount financed and credit history. An applicant’s rate will never increase.`,
        modalContent: 'Installment Loans are issued by LendingClub Bank, N.A., Member FDIC, Equal Housing Lender ("LendingClub Bank"). LendingClub Bank offers multiple Installment Loan plans, the availability of which varies by provider. Not all plans may be available through your selected provider. Credit terms depend upon credit score and other key financing characteristics, including but not limited to the amount financed, loan term length, and your credit usage and history.'
      };

    return {
      title: 'Promotional Rate Plans (Low APR, Equal Payment Required)',
      subTitle: 'Revolving Line of Credit',
      description: shouldShowUpdatedAdsTerms ? NonPniNewPRPDescription : NonPniOldPRPDescription,
      modalContent: shouldShowUpdatedAdsTerms ? NonPniNewPRPModalContent : NonPniOldPRPModalContent
    };
  }
}

export default NonPNI;

